
<spinner-icon></spinner-icon>
<div class="text" *ngIf="text">{{text}}</div>